<div class="container cl-form " [formGroup]="poFormGroup">
  <div class="row cl-spacing-small">
    <div class="col-6">
      <label for="projectid" class="form-label">Project ID</label>
      <input id="projectid" type="text" formControlName="po_number" pattern="[A-Za-z0-9_\.\-\/]+">
      @if (poFormGroup.controls.po_number.errors?.required) {
        <p class="invalid-feedback">This field is required.</p>
      }
      @if (poFormGroup.controls.po_number.errors?.pattern) {
        <p class="invalid-feedback">Only letters, numbers and '_', '-', '/' or '.' are allowed</p>
      }
      @if (!poFormGroup.controls.po_number.errors) {
        <p class="valid-feedback">The Project ID groups related encodes for easier reference and organization.</p>
      }
    </div>
    <div class="col-3">
      <label for="po_destination" class="form-label">Delivery Destination<span class="required">*</span></label>
      <select id="po_destination" class="form-select" formControlName="po_destination"
        [compareWith]="compare_destination_id">
        @for (sys of poDestinations; track sys) {
          <option [value]="sys.destination_id">{{ sys.display_name }}</option>
        }
      </select>
      @if (poFormGroup.controls.po_destination.errors?.required) {
        <p class="invalid-feedback">This field is required.</p>
      }
      @if (!poFormGroup.controls.po_destination.errors) {
        <p class="valid-feedback">Select the desired destination.</p>
      }
    </div>

    <div class="col-3 ">
      <label for="auto_publish" class="form-label">Publication</label>
      <select id="auto_publish" class="form-select" formControlName="auto_publish">
        <option [value]="true"> Automatic Publication
        </option>
        <option [value]="false"> Manual Publication
        </option>
      </select>
      <p class="valid-feedback">Manual Publication allows for a final QA step before distributing the content, whereas Automatic Publication releases the content immediately upon readiness.</p>
    </div>

  </div>

  <div class="row cl-spacing-small">
    <div class="col-12">
      @if (poItems.controls.length > 0) {
        <h2>PO Items</h2>
      }
    </div>
  </div>
  <ng-container formArrayName="poItems">

    @for (item of poItems.controls ; track poItemTrackBy(idx, item); let idx = $index) {
      <ng-container [formGroup]="poItems.controls[idx]" [formGroupName]="idx"
        >
        <div class="row cl-spacing-small">
          <div class="col-12">
            <h3  [class.warn]="poItems.controls[idx].invalid">{{ poItems.controls[idx].value['basics']['po_item_id'] }}<button class="cl-a-quickaction"  (click)="poService.removePOItem(poItems.controls[idx].value['id'])">Remove</button></h3>
          </div>
        </div>
        <input id="idinput" type="hidden" formControlName="id">
        <app-basic-poitem-vod-info formControlName="basics" poItemIdLabel="Title"></app-basic-poitem-vod-info>
        <app-vod-repackaging-format-specific formControlName="format_specific_data"></app-vod-repackaging-format-specific>
        <div class="row">
          <div class="col-12">
            <hr class="cl-spacing-small">
          </div>
        </div>
      </ng-container>
    }


  </ng-container>
  <div class="row">
    <div class="col-12">

      <div class=" cl-spacing-box text-end">
        <app-message-field #messages></app-message-field>
        <app-do-button buttonClass="btn cl-color-primary"  [messageField]="messages" (actionTriggered)="submit_po($event)" >
          <span>Start encode</span>
        </app-do-button>
      </div>
    </div>
  </div>

</div>
